import { render, staticRenderFns } from "./Kaiji.vue?vue&type=template&id=81ed67b6&scoped=true&"
import script from "./Kaiji.vue?vue&type=script&lang=js&"
export * from "./Kaiji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ed67b6",
  null
  
)

export default component.exports